export enum RecourseTypeIdEnum {
  RECOURSE = 1,
  CAMPAIGN = 2,
  RAD = 3,
  AFTERSALES = 4,
}
